import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { useMemo } from "react";
import { ITag } from "@/common/services/types";
import { useGetTrendingTags } from "@/common/hooks/useGetTrendingTags";

const MAX_DESKTOP_ITEMS = 5;
const MAX_MOBILE_ITEMS = 3;

export const useTrendingTags = () => {
  const deviceType = useDeviceType();
  const isPhone = useMemo(() => deviceType === deviceTypeEnum.PHONE, [deviceType]);
  const { trendingTags, isLoading } = useGetTrendingTags();

  const adaptedTrendingTags = useMemo(() => {
    const modifiedTrendingTags = trendingTags.map((item: ITag) => ({ type: "tag", text: item.name, gifs: item.count })) || [];
    return modifiedTrendingTags.slice(0, isPhone ? MAX_MOBILE_ITEMS : MAX_DESKTOP_ITEMS);
  }, [trendingTags, isPhone]);

  return {
    trendingTags: adaptedTrendingTags,
    isLoading
  };
};
